import React from 'react';
import {connect} from 'react-redux';
import env from "../env";
import {refreshView} from 'react-admin';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from '@material-ui/core/Button';
import {downloadFile} from "./FileDownload";


const styles = {
    button: {
        margin: 1,
        width: 180
    },
}

class DownloadFileContentButton extends React.Component {

    state = {
        id: null,
        showBtn: false,
        basePath: '',
        urlPrefix: env.baseURL,
        fileExtension: '.xlsx',
    };

    constructor(props) {
        super(props);
        if (props.record) {
            this.state.id = props.record.id;
            this.state.showBtn = props.record.hasContent;
            this.state.basePath = props.basePath;
            const extension = props.extension;
            if (extension) {
                this.state.fileExtension = extension
            }
            const urlPrefix = props.urlPrefix;
            if (urlPrefix) {
                this.state.urlPrefix = urlPrefix
            }
        }
    }

    handleClick = (e) => {
        e.stopPropagation();
        downloadFile(this.getDownloadUrl(), this.state.id + this.state.fileExtension)
    };

    getDownloadUrl() {
        return this.state.urlPrefix + `/api` + this.state.basePath + '/getContent?id=' + this.state.id;
    };

    render() {
        return (
            <div>
                {this.state.showBtn &&
                <Button color="primary" style={styles.button}
                        onClick={this.handleClick}>
                    <GetAppIcon/> File nhập liệu
                </Button>
                }

            </div>
        )
    }

}

export default connect(null, {refreshView})(DownloadFileContentButton);
